export default {
  SLEEPOVER: 'Sleepover',
  SLEEPOVER_ID: 4
}
